import React from "react";
import UTILS from "../../utils/commons";
import avatar from "../../img/no_data.svg";
import { Mail, MapPin, PersonStanding, Phone } from "lucide-react";

const StaffItem = ( props ) => {

    var p = props.data;
    return (
        <div className="cursor-pointer border-t border-gray-100 p-3 flex justify-between items-center hover:bg-gray-50">

            <img className="item-image" alt={p.firstName} src={( p.profileImage || p.managerImage ) ? ( p.profileImage || p.managerImage ) : avatar} onClick={( id ) => props.onClick( id )} />
            <div className="item-data" onClick={( id ) => props.onClick( id )}>
                <span className="item-title text-gray-800 font-semibold"><a className="hover:underline" href={`/staff/view/${p.id}`}>{p.auth.firstName + " " + p.auth.lastName}</a></span>
                <div className="flex space-x-4 text-secondary-500">
                    <span className="flex items-center"><MapPin className="h-4" /> &nbsp;{p.serviceArea}</span>
                    <span className="flex items-center"><Phone className="h-4" /> &nbsp;{p.phone}</span>
                    <span className="items-center hidden md:flex"><Mail className="h-4" /> &nbsp;{p.auth.email}</span>
                    <span className="items-center hidden md:flex"><PersonStanding className="h-4" /> &nbsp;{p.auth.role}</span>
                </div>
            </div>
            <div className="flex flex-col gap-2 item-actions">
                <span className="material-icons" onClick={( id ) => props.onEdit( id )}>edit</span>
                <span className="material-icons" onClick={( id ) => props.onDelete( id )}>delete</span>
            </div>
        </div>
    )
}
export default StaffItem;